module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av622-358f388ce4a5507295b6a6b32d3a13cd.jpg";